export const bookingGateFilter = {
  MEALPLAN: 'bookingGateFilter.mealplan',
  DURATIONS: 'bookingGateFilter.durations',
  MONTH: 'bookingGateFilter.month',
  ROOM_TYPES: 'bookingGateFilter.roomTypes',
  TRANSPORT: 'bookingGateFilter.transportType',
  PARTICIPANTS: 'bookingGateFilter.participants',
  AIRPORTS: 'bookingGateFilter.airports'
}
